
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32CBT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc08d04e21e26787$export$947d923eb7e59d5c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3GQfQ",
    name: "PublishModal",
    loader: async ()=>{
        return (await (parcelRequire("3lqKZ"))).PublishModal;
    }
});

const $fc08d04e21e26787$export$5a1c1fd1fd0d9704 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5nfIQ",
    name: "DiscardModal",
    loader: async ()=>{
        return (await (parcelRequire("dpItF"))).DiscardModal;
    }
});

const $fc08d04e21e26787$export$6bd5113474000445 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Xm8EX",
    name: "CancelSchedulePublishModal",
    loader: async ()=>{
        return (await (parcelRequire("9MxoE"))).CancelSchedulePublishModal;
    }
});
module.exports["PublishModal"] = $fc08d04e21e26787$export$947d923eb7e59d5c;
module.exports["DiscardModal"] = $fc08d04e21e26787$export$5a1c1fd1fd0d9704;
module.exports["CancelSchedulePublishModal"] = $fc08d04e21e26787$export$6bd5113474000445;

});

parcelRegister("3lqKZ", function(module, exports) {

let $26f8169e6ee80cab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $26f8169e6ee80cab$var$load("49GA1"),
    $26f8169e6ee80cab$var$load("32K9i"),
    $26f8169e6ee80cab$var$load("aeEUI"),
    $26f8169e6ee80cab$var$load("6wr18"),
    $26f8169e6ee80cab$var$load("kahM9"),
    $26f8169e6ee80cab$var$load("iXzmH"),
    $26f8169e6ee80cab$var$load("65c4i"),
    $26f8169e6ee80cab$var$load("kHOMt"),
    $26f8169e6ee80cab$var$load("hhss7"),
    $26f8169e6ee80cab$var$load("Wowvf"),
    $26f8169e6ee80cab$var$load("7EorR"),
    $26f8169e6ee80cab$var$load("ffEVr"),
    $26f8169e6ee80cab$var$load("kUbUu"),
    $26f8169e6ee80cab$var$load("anQQJ")
]).then(()=>parcelRequire('9V1Xo'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("dpItF", function(module, exports) {

let $9c401c7760552786$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c401c7760552786$var$load("hhss7"),
    $9c401c7760552786$var$load("fCqMy")
]).then(()=>parcelRequire('hpcRG'));

});

parcelRegister("9MxoE", function(module, exports) {

let $71f2809dfacff0df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $71f2809dfacff0df$var$load("hhss7"),
    $71f2809dfacff0df$var$load("a6uKK")
]).then(()=>parcelRequire('ic1wA'));

});

parcelRegister("ibgjl", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $a4TK8 = parcelRequire("a4TK8");


var $7aRa9 = parcelRequire("7aRa9");


var $gqqjz = parcelRequire("gqqjz");


var $ep3mz = parcelRequire("ep3mz");


var $bT0se = parcelRequire("bT0se");


var $8mrqR = parcelRequire("8mrqR");
/**
 * @graphql cc
 */ 









var $inPa6 = parcelRequire("inPa6");


var $7PLO8 = parcelRequire("7PLO8");




const $0881c56c6dd240f3$var$useFetchRestrictionsRESTObjRestrictionsRESTQuery = (0, $eSUdr.default)`query useFetchRestrictionsRESTObjRestrictionsRESTQuery($contentId:ID!$draftShareId:String){content(id:$contentId status:["current" "draft"]draftShareId:$draftShareId){nodes{id type restrictions{read{operation restrictions{groupWithRestrictions{nodes{id name usageType}}userWithRestrictions{nodes{accountId displayName email hasSpaceEditPermission hasSpaceViewPermission permissionType publicName profilePicture{path}type}}}}update{operation restrictions{groupWithRestrictions{nodes{id name usageType}}userWithRestrictions{nodes{accountId displayName email hasSpaceEditPermission hasSpaceViewPermission permissionType publicName profilePicture{path}type}}}}}}}}`;
const $0881c56c6dd240f3$export$8596aed048cdf431 = ({ contentId: contentId, onSuccess: onSuccess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [transformationError, setTransformationError] = (0, $42omo.useState)(undefined);
    const { data: data, error: error, refetch: refetch } = (0, $xQxzY.useQuery)($0881c56c6dd240f3$var$useFetchRestrictionsRESTObjRestrictionsRESTQuery, {
        variables: {
            contentId: contentId,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        // Without this setting, onCompleted will not fire on refetches
        // See: https://github.com/apollographql/react-apollo/issues/3709#issuecomment-592786578
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        onCompleted: (completedData)=>{
            try {
                onSuccess?.((0, $8mrqR.transformGraphQLQueryToRESTObj)(completedData));
                setTransformationError(undefined);
            } catch (restrictionsError) {
                setTransformationError(restrictionsError);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'fetchRestrictions',
                        actionSubjectId: 'fetchRestrictionsError',
                        source: 'useFetchRestrictionsRESTObj',
                        attributes: {
                            message: restrictionsError.message
                        }
                    }
                }).fire();
            }
        }
    });
    const fetchedRestrictions = (0, $42omo.useMemo)(()=>{
        if (data) {
            let transformedData = undefined;
            try {
                transformedData = (0, $8mrqR.transformGraphQLQueryToRESTObj)(data);
            } catch (restrictionsError) {
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'fetchRestrictions',
                        actionSubjectId: 'fetchRestrictionsError',
                        source: 'useFetchRestrictionsRESTObj',
                        attributes: {
                            message: restrictionsError.message
                        }
                    }
                }).fire();
            }
            return transformedData;
        } else return undefined;
    }, [
        data,
        createAnalyticsEvent
    ]);
    return {
        fetchedRestrictions: fetchedRestrictions,
        error: error || transformationError,
        refetch: refetch
    };
};



var $9wGTI = parcelRequire("9wGTI");


var $i9VoI = parcelRequire("i9VoI");


var $4VJDS = parcelRequire("4VJDS");


var $6mKj3 = parcelRequire("6mKj3");


var $jVFPV = parcelRequire("jVFPV");

const $8e5ec683a0a81bad$var$DEFAULT_SETTINGS = {
    pendingScheduledPublishDate: undefined,
    versionComments: '',
    publishAsBlog: false,
    shouldNotify: true,
    moveParams: undefined,
    restrictionsRestObj: undefined
};
const $8e5ec683a0a81bad$export$df066e33be73e48e = ()=>Promise.resolve({
        title: '',
        adf: {
            type: ''
        }
    });
const $8e5ec683a0a81bad$export$5bbc09a836707eff = /*#__PURE__*/ (0, $42omo.createContext)({
    ...$8e5ec683a0a81bad$var$DEFAULT_SETTINGS,
    currentlyScheduledPublishDate: undefined,
    setCurrentlyScheduledPublishDate: ()=>{},
    setPendingScheduledPublishDate: ()=>{},
    scheduledPublishDate: undefined,
    setVersionComments: ()=>{},
    setPublishAsBlog: ()=>{},
    expanded: false,
    setExpanded: ()=>{},
    setShouldNotify: ()=>{},
    setRestrictionsRestObj: ()=>{},
    hasModifiedRestrictions: false,
    refetchAll: ()=>{},
    shouldNotifyComputedValue: true,
    discardCurrentState: ()=>{},
    graphqlError: undefined,
    restrictionsGraphQLError: undefined,
    onClickPublish: ()=>{},
    onClickPreview: ()=>{},
    retrieveEditorTitleAndContent: $8e5ec683a0a81bad$export$df066e33be73e48e,
    flags: new (0, $gqqjz.FlagsStateContainer)([]),
    hasModifiedSettings: true,
    isBlog: false,
    setIsBlog: ()=>{},
    setMoveParams: ()=>{},
    hasModifiedLocation: false,
    hasScheduledRestrictions: false,
    setHasScheduledRestrictions: ()=>{},
    isConvertToPageDialog: false
});
const $8e5ec683a0a81bad$export$d831d07c578114dd = ()=>{
    const [currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate] = (0, $42omo.useState)(undefined);
    const [pendingScheduledPublishDate, setPendingScheduledPublishDate] = (0, $42omo.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.pendingScheduledPublishDate);
    const [versionComments, setVersionComments] = (0, $42omo.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.versionComments);
    const [publishAsBlog, setPublishAsBlog] = (0, $42omo.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishAsBlog);
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [shouldNotify, setShouldNotify] = (0, $42omo.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.shouldNotify);
    // undefined indicates that no user-initiated changes have been mode to restrictions
    const [restrictionsRestObj, setRestrictionsRestObj] = (0, $42omo.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.restrictionsRestObj);
    const [savedSnapshot, setSavedSnapshot] = (0, $42omo.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS);
    const [hasScheduledRestrictions, setHasScheduledRestrictions] = (0, $42omo.useState)(false);
    const [isBlog, setIsBlog] = (0, $42omo.useState)(false);
    const [moveParams, setMoveParams] = (0, $42omo.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.moveParams);
    // When the publish modal opens and a date is already scheduled on the backend,
    // the pendingScheduledPublishDate is set to undefined to indicate there is
    // no date picked by the user, while the currentlyScheduledPublishDate will
    // have the actualy scheduled date value.
    // This check prevents that situation from triggering the discard dialog.
    const hasModifiedDate = currentlyScheduledPublishDate?.getTime() !== pendingScheduledPublishDate?.getTime() && pendingScheduledPublishDate !== undefined;
    const hasModifiedRestrictions = restrictionsRestObj !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(savedSnapshot.restrictionsRestObj, restrictionsRestObj);
    const hasModifiedLocation = savedSnapshot.publishAsBlog !== publishAsBlog || savedSnapshot.moveParams !== moveParams;
    const hasModifiedSettings = hasModifiedDate || savedSnapshot.versionComments !== versionComments || savedSnapshot.shouldNotify !== shouldNotify || hasModifiedLocation || hasModifiedRestrictions;
    /* Function to discard current state on modal close */ const discardCurrentState = ()=>{
        setPendingScheduledPublishDate($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.pendingScheduledPublishDate);
        setVersionComments($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.versionComments);
        setPublishAsBlog($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishAsBlog);
        setShouldNotify($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.shouldNotify);
        setMoveParams($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.moveParams);
        setRestrictionsRestObj($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.restrictionsRestObj);
        setSavedSnapshot($8e5ec683a0a81bad$var$DEFAULT_SETTINGS);
    };
    const scheduledPublishDate = pendingScheduledPublishDate ?? currentlyScheduledPublishDate;
    return {
        currentlyScheduledPublishDate: currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate,
        pendingScheduledPublishDate: pendingScheduledPublishDate,
        setPendingScheduledPublishDate: setPendingScheduledPublishDate,
        versionComments: versionComments,
        setVersionComments: setVersionComments,
        publishAsBlog: publishAsBlog,
        setPublishAsBlog: setPublishAsBlog,
        expanded: expanded,
        setExpanded: setExpanded,
        shouldNotify: shouldNotify,
        setShouldNotify: setShouldNotify,
        restrictionsRestObj: restrictionsRestObj,
        setRestrictionsRestObj: setRestrictionsRestObj,
        hasModifiedRestrictions: hasModifiedRestrictions,
        scheduledPublishDate: scheduledPublishDate,
        discardCurrentState: discardCurrentState,
        savedSnapshot: savedSnapshot,
        setSavedSnapshot: setSavedSnapshot,
        hasModifiedSettings: hasModifiedSettings,
        isBlog: isBlog,
        setIsBlog: setIsBlog,
        setMoveParams: setMoveParams,
        moveParams: moveParams,
        hasModifiedLocation: hasModifiedLocation,
        hasScheduledRestrictions: hasScheduledRestrictions,
        setHasScheduledRestrictions: setHasScheduledRestrictions
    };
};
const $8e5ec683a0a81bad$export$d24968a4528c903e = (0, $7aRa9.withFlags)(({ children: children, onClickPublish: onClickPublish, onClickPreview: onClickPreview, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, isConvertToPageDialog: isConvertToPageDialog = false })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    /* State declarations */ const { currentlyScheduledPublishDate: currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate, pendingScheduledPublishDate: pendingScheduledPublishDate, setPendingScheduledPublishDate: setPendingScheduledPublishDate, versionComments: versionComments, setVersionComments: setVersionComments, publishAsBlog: publishAsBlog, setPublishAsBlog: setPublishAsBlog, expanded: expanded, setExpanded: setExpanded, shouldNotify: shouldNotify, setShouldNotify: setShouldNotify, restrictionsRestObj: restrictionsRestObj, setRestrictionsRestObj: setRestrictionsRestObj, hasModifiedRestrictions: hasModifiedRestrictions, scheduledPublishDate: scheduledPublishDate, discardCurrentState: discardCurrentState, savedSnapshot: savedSnapshot, setSavedSnapshot: setSavedSnapshot, hasModifiedSettings: hasModifiedSettings, isBlog: isBlog, setIsBlog: setIsBlog, setMoveParams: setMoveParams, moveParams: moveParams, hasModifiedLocation: hasModifiedLocation, hasScheduledRestrictions: hasScheduledRestrictions, setHasScheduledRestrictions: setHasScheduledRestrictions } = $8e5ec683a0a81bad$export$d831d07c578114dd();
    const onSchedulePublishPubsubEvent = (0, $42omo.useCallback)((_, payload)=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '')) || !(0, $6mKj3.expVal)('cc_fps_migration_scheduled-publish', 'isEnabled', false)) {
            const { schedulePublishRequestBody: { publishTime: publishTime, eventType: eventType } } = payload;
            if (eventType === 'scheduled') {
                if (!currentlyScheduledPublishDate || currentlyScheduledPublishDate?.toISOString() !== publishTime) setCurrentlyScheduledPublishDate(new Date(publishTime));
            } else if (eventType === 'unscheduled') {
                if (currentlyScheduledPublishDate) setCurrentlyScheduledPublishDate(undefined);
            }
        }
    }, [
        currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate
    ]);
    const onSchedulePublishSubscriptionEvent = (0, $42omo.useCallback)((_delta, response)=>{
        const { eventType: eventType, publishTime: publishTime } = response?.schedulePublished || {};
        if (eventType === 'SCHEDULED') {
            if (!currentlyScheduledPublishDate || currentlyScheduledPublishDate?.toISOString() !== publishTime) setCurrentlyScheduledPublishDate(new Date(publishTime));
        } else if (eventType === 'UNSCHEDULED') {
            if (currentlyScheduledPublishDate) setCurrentlyScheduledPublishDate(undefined);
        }
    }, [
        currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate
    ]);
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId ?? '',
        contentType: contentType ?? 'page',
        eventName: contentType === 'blogpost' ? 'schedulePublish:blogpost' : 'schedulePublish:page',
        onEvent: onSchedulePublishPubsubEvent,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('cc_fps_migration_scheduled-publish', 'isEnabled', false) && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId ?? '',
        contentType: contentType ?? 'page',
        subscriberId: 'PublishModalContextSubscription',
        delta: 'schedulePublished',
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        !(0, $6mKj3.expVal)('cc_fps_migration_scheduled-publish', 'isEnabled', false) || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') || ![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '')),
        onDataReceived: onSchedulePublishSubscriptionEvent
    });
    const { error: restrictionsGraphQLError, refetch: refetchRestrictions } = (0, $0881c56c6dd240f3$export$8596aed048cdf431)({
        contentId: contentId ?? '',
        onSuccess: (newRestrictions)=>// Snapshot should match scheduled restrictions instead of true restrictions
            !hasScheduledRestrictions && setSavedSnapshot({
                ...savedSnapshot,
                restrictionsRestObj: newRestrictions
            })
    });
    const isFirstTimeBlogPost = isUnpublishedDraft && isBlog;
    let shouldNotifyComputedValue = shouldNotify;
    const computedRestrictions = hasModifiedRestrictions ? restrictionsRestObj : savedSnapshot.restrictionsRestObj;
    if (computedRestrictions && (0, $8mrqR.restrictionsArePrivateToYouOnly)(computedRestrictions)) shouldNotifyComputedValue = false;
    else if (publishAsBlog || isFirstTimeBlogPost) shouldNotifyComputedValue = true;
    const loadQueryDataIntoPublishModalState = (newQueryData)=>{
        let nextCurrentlyScheduledPublishDate;
        let nextPendingScheduledPublishDate;
        let nextExpanded = expanded;
        let nextShouldNotify;
        let nextPublishAsBlog = publishAsBlog;
        let nextRestrictionsRestObj = restrictionsRestObj;
        let nextmoveParams = moveParams;
        const schedulePublishInfo = newQueryData?.singleContent?.schedulePublishInfo;
        if (schedulePublishInfo?.date) {
            nextCurrentlyScheduledPublishDate = new Date(Date.parse(schedulePublishInfo?.date));
            nextPendingScheduledPublishDate = undefined;
            nextExpanded = true;
        } else {
            nextCurrentlyScheduledPublishDate = undefined;
            nextPendingScheduledPublishDate = undefined;
        }
        const nextVersionComments = schedulePublishInfo?.versionComment ?? '';
        if (typeof schedulePublishInfo?.minorEdit === 'boolean') // if minorEdit==false then we should notify
        nextShouldNotify = !schedulePublishInfo?.minorEdit;
        else // if we don't have a value for this, set to true which is the default
        nextShouldNotify = true;
        nextPublishAsBlog = schedulePublishInfo?.targetType === 'blogpost' && newQueryData?.singleContent?.type !== 'blogpost';
        const targetLocation = schedulePublishInfo?.targetLocation;
        if (targetLocation?.destinationSpace?.key) {
            nextmoveParams = {
                newSpaceKey: targetLocation?.destinationSpace?.alias || targetLocation?.destinationSpace?.key
            };
            if (targetLocation?.parentId) nextmoveParams = {
                ...nextmoveParams,
                newParentPageId: targetLocation?.parentId
            };
        }
        if (schedulePublishInfo?.restrictions) {
            setHasScheduledRestrictions(true);
            nextRestrictionsRestObj = (0, $jVFPV.convertRestrictionsObjFromSchedulePublishInfo)(schedulePublishInfo?.restrictions);
        }
        setCurrentlyScheduledPublishDate(nextCurrentlyScheduledPublishDate);
        setPendingScheduledPublishDate(nextPendingScheduledPublishDate);
        setExpanded(nextExpanded);
        setVersionComments(nextVersionComments);
        setShouldNotify(nextShouldNotify);
        setPublishAsBlog(nextPublishAsBlog);
        setRestrictionsRestObj(nextRestrictionsRestObj);
        setMoveParams(nextmoveParams);
        // TODO: GENI-2751 - Read staged locations from schedule publish info
        // and stage to snapshot with moveParams
        setSavedSnapshot((oldSavedSnapshot)=>({
                pendingScheduledPublishDate: nextPendingScheduledPublishDate,
                versionComments: nextVersionComments,
                publishAsBlog: nextPublishAsBlog,
                shouldNotify: nextShouldNotify,
                moveParams: nextmoveParams,
                // If savedSnapshot.restrictionsRestObj has just been set by useFetchRestrictionsRESTObj, we need to not override what it just set.
                restrictionsRestObj: nextRestrictionsRestObj ?? oldSavedSnapshot.restrictionsRestObj
            }));
    };
    /* Fetching already scheduled publish data */ const { data: queryData, error: graphqlError, refetch: refetchPublishModalQuery } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query PublishModalContextPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id type space{id}schedulePublishInfo{date versionComment minorEdit targetType targetLocation{parentId destinationSpace{id key alias}}restrictions{update{user:personConnection{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}read{user:personConnection{edges{node{email permissionType displayName accountId publicName profilePicture{path}}}}group{edges{node{name id}}}}}}}}`, {
        errorPolicy: 'all',
        fetchPolicy: 'cache-and-network',
        variables: {
            contentId: contentId
        },
        onCompleted: loadQueryDataIntoPublishModalState
    });
    (0, $42omo.useEffect)(()=>{
        const schedulePublishDateFromQuery = queryData?.singleContent?.schedulePublishInfo?.date;
        if (schedulePublishDateFromQuery) {
            const newSchedulePublishDateFromQuery = new Date(Date.parse(schedulePublishDateFromQuery));
            setCurrentlyScheduledPublishDate(newSchedulePublishDateFromQuery);
        }
    }, [
        queryData?.singleContent?.schedulePublishInfo?.date,
        setCurrentlyScheduledPublishDate
    ]);
    const resetToInitialState = ()=>{
        if (queryData?.singleContent?.schedulePublishInfo?.date) // If this page is currently scheduled to be published,
        // then load the settings of the current scheduled publish from the backend.
        loadQueryDataIntoPublishModalState(queryData);
        else discardCurrentState();
    };
    const refetchAll = (0, $42omo.useCallback)(()=>{
        refetchPublishModalQuery();
        refetchRestrictions();
    }, [
        refetchPublishModalQuery,
        refetchRestrictions
    ]);
    /* Objects that are provided via the context */ const contextProvidedData = {
        currentlyScheduledPublishDate: currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate,
        pendingScheduledPublishDate: pendingScheduledPublishDate,
        setPendingScheduledPublishDate: setPendingScheduledPublishDate,
        scheduledPublishDate: scheduledPublishDate,
        versionComments: versionComments,
        setVersionComments: setVersionComments,
        publishAsBlog: publishAsBlog,
        setPublishAsBlog: setPublishAsBlog,
        expanded: expanded,
        setExpanded: setExpanded,
        shouldNotify: shouldNotify,
        setShouldNotify: setShouldNotify,
        restrictionsRestObj: computedRestrictions,
        setRestrictionsRestObj: setRestrictionsRestObj,
        hasModifiedRestrictions: hasModifiedRestrictions,
        refetchAll: refetchAll,
        shouldNotifyComputedValue: shouldNotifyComputedValue,
        graphqlError: graphqlError,
        restrictionsGraphQLError: restrictionsGraphQLError,
        discardCurrentState: resetToInitialState,
        onClickPublish: onClickPublish,
        onClickPreview: onClickPreview,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        flags: flags,
        hasModifiedSettings: hasModifiedSettings,
        isBlog: isBlog,
        setIsBlog: setIsBlog,
        setMoveParams: setMoveParams,
        moveParams: moveParams,
        hasModifiedLocation: hasModifiedLocation,
        hasScheduledRestrictions: hasScheduledRestrictions,
        setHasScheduledRestrictions: setHasScheduledRestrictions,
        isConvertToPageDialog: isConvertToPageDialog
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e5ec683a0a81bad$export$5bbc09a836707eff.Provider, {
        value: contextProvidedData
    }, children);
});
const $8e5ec683a0a81bad$export$c88291018b2907cc = (WrappedComponent)=>({ onClickPublish: onClickPublish, onClickPreview: onClickPreview, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, isConvertToPageDialog: isConvertToPageDialog, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e5ec683a0a81bad$export$d24968a4528c903e, {
            onClickPublish: onClickPublish,
            onClickPreview: onClickPreview,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            isUnpublishedDraft: isUnpublishedDraft,
            contentType: contentType,
            isConvertToPageDialog: isConvertToPageDialog
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            isUnpublishedDraft: isUnpublishedDraft,
            contentType: contentType,
            ...props
        }));
    };
module.exports["PublishModalContext"] = $8e5ec683a0a81bad$export$5bbc09a836707eff;
module.exports["withPublishModalContextProvider"] = $8e5ec683a0a81bad$export$c88291018b2907cc;

});

parcelRegister("4f2ij", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $ep3mz = parcelRequire("ep3mz");


var $32CBT = parcelRequire("32CBT");


var $ibgjl = parcelRequire("ibgjl");





var $7CLBv = parcelRequire("7CLBv");


var $lgKMU = parcelRequire("lgKMU");




const $ebcc7d0d34ae1e7f$export$13cacc04cd9a5e8b = ({ onClose: onClose, contentId: contentId, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft })=>{
    const { restrictionsRestObj: restrictionsRestObj, setRestrictionsRestObj: setRestrictionsRestObj, hasModifiedRestrictions: hasModifiedRestrictions, hasScheduledRestrictions: hasScheduledRestrictions } = (0, $42omo.useContext)((0, $ibgjl.PublishModalContext));
    const setRestrictionsDeepCopy = (newVal)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(newVal);
        setRestrictionsRestObj(clone);
    };
    const preloadRestrictions = hasModifiedRestrictions || hasScheduledRestrictions ? restrictionsRestObj : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgKMU.ShareAndRestrictDialogController), {
        contentId: contentId,
        contentType: contentType,
        allowRestrictions: true,
        pageModes: "view",
        refetchButtonData: ()=>{},
        onClose: onClose,
        publishModalRestrictions: preloadRestrictions,
        pushPublishModalRestrictions: setRestrictionsDeepCopy,
        isUnpublishedDraft: isUnpublishedDraft
    });
};


const $5ded9942f908b7ae$export$2ade9573a6e2bedc = ({ isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, title: title, publishButtonDisabled: publishButtonDisabled, userViewingPreview: userViewingPreview, initialFocusTarget: initialFocusTarget, shouldShowWorldIcon: shouldShowWorldIcon, shouldShowFooterButtons: shouldShowFooterButtons = true, onPublishModalComplete: onPublishModalComplete })=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { discardCurrentState: discardCurrentState, hasModifiedSettings: hasModifiedSettings, refetchAll: refetchAll } = (0, $42omo.useContext)((0, $ibgjl.PublishModalContext));
    const [publishModalIsOpen, setPublishModalIsOpen] = (0, $42omo.useState)(true);
    const [discardModalIsOpen, setDiscardModalIsOpen] = (0, $42omo.useState)(false);
    // A ref is needed here so queuedFinalClose can have its value update right away.
    // It is not used in any render functions, so it's OK to use a ref here.
    const queuedFinalCloseRef = (0, $42omo.useRef)(false);
    const [focusField, setFocusField] = (0, $42omo.useState)(initialFocusTarget);
    const [permissionsDialogIsOpen, setPermissionsDialogIsOpen] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        // We need to refetch the PublishModal state immediately before opening the modal so we can be sure we have the latest settings.
        refetchAll();
    }, [
        refetchAll
    ]);
    const openPermissionsDialog = ()=>{
        setPermissionsDialogIsOpen(true);
    };
    const closePermissionsDialog = ()=>{
        setPermissionsDialogIsOpen(false);
    };
    /*
	 * The openModal function below opens the publish modal.
	 * It is sometimes used to return to the publish modal after its sub-dialogs (like the permissions dialog) are closed.
	 */ const openModal = (focus)=>{
        setPublishModalIsOpen(true);
        setFocusField(focus);
    };
    // The boolean endPublishExperience should be true if this closes all sub-modals and ends the PublishModal experience.
    // If endPublishExperience is false, the PublishModal will be closed but the PublishModal experience will continue, so other sub-modals like the MovePageDialog can render.
    const closeModal = ({ endPublishExperience: endPublishExperience })=>{
        if (endPublishExperience) queuedFinalCloseRef.current = true;
        setPublishModalIsOpen(false);
    };
    const onCloseComplete = ()=>{
        if (queuedFinalCloseRef.current) onPublishModalComplete();
    };
    const requestCloseModal = ()=>{
        if (hasModifiedSettings) setDiscardModalIsOpen(true);
        else {
            discardCurrentState();
            closeModal({
                endPublishExperience: true
            });
        }
    };
    const closeDiscardModal = ()=>{
        setDiscardModalIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, publishModalIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32CBT.PublishModal), {
        publishButtonDisabled: publishButtonDisabled,
        closeModal: closeModal,
        openModal: openModal,
        requestCloseModal: requestCloseModal,
        onCloseComplete: onCloseComplete,
        isUnpublishedDraft: isUnpublishedDraft,
        openPermissionsDialog: ()=>{
            closeModal({
                endPublishExperience: false
            });
            openPermissionsDialog();
        },
        userViewingPreview: userViewingPreview,
        title: title,
        focusField: focusField,
        setFocusField: setFocusField,
        shouldShowWorldIcon: shouldShowWorldIcon,
        shouldShowFooterButtons: shouldShowFooterButtons
    })), permissionsDialogIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ebcc7d0d34ae1e7f$export$13cacc04cd9a5e8b), {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            closePermissionsDialog();
            openModal('access');
        },
        isUnpublishedDraft: isUnpublishedDraft
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, discardModalIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32CBT.DiscardModal), {
        closeModal: closeModal,
        closeDiscardModal: closeDiscardModal,
        isUnpublishedDraft: isUnpublishedDraft
    })));
};
module.exports["PublishModalDialogs"] = $5ded9942f908b7ae$export$2ade9573a6e2bedc;

});


//# sourceMappingURL=PublishButtonWithMoreOptions.9252f7d4.js.map
